export default {
  path: 'declare',
  component: () => import(/* webpackChunkName: "roles-list" */ '@/pages/taxReturn/declare'),
  meta: {title:'申报中心',cate:'个人申报'},
  children: [
    {
      path: 'declareView',
      component: () => import(/* webpackChunkName: "manage-members" */ '@/pages/taxReturn/companyDetail'),
      meta: {title:'申报明细'},
    }
  ]
}